import React from 'react';

import './plaid-product-types-container.scss';

const ProductTypesContainer = props => (
  <div className={'plaid-product-container'}>
    <h4 className={'plaid-product-header'}>{props.productType}</h4>
    {props.children}
  </div>
)

ProductTypesContainer.displayName = 'TypeContainer'

export default ProductTypesContainer
